import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { RootCanvasFieldData } from '../hooks/useProcessModuleRootCanvas';

interface RootFieldSelectorProps {
  currentReferencedFieldId?: string;
  rootFields: RootCanvasFieldData[];
  isSubmitting: boolean;
  onRootFieldSelect: (rootFieldId: string) => void;
}

export const RootFieldSelector = ({
  currentReferencedFieldId,
  rootFields,
  isSubmitting,
  onRootFieldSelect,
}: RootFieldSelectorProps) => {
  return (
    <Stack spacing={2}>
      <Typography variant="h6">Select Root Canvas Field</Typography>

      <FormControl fullWidth>
        <InputLabel>Root Field</InputLabel>
        <Select
          value={currentReferencedFieldId || ''}
          label="Root Field"
          onChange={(e) => onRootFieldSelect(e.target.value)}
          disabled={isSubmitting}
        >
          <MenuItem value="">
            <em>Select a root field...</em>
          </MenuItem>
          {rootFields.map((rootField) => (
            <MenuItem key={rootField.fieldId} value={rootField.fieldId}>
              <Stack>
                <Typography variant="body1" fontWeight="bold">
                  {rootField.fieldLabel}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {rootField.formName} • Template: {rootField.templateId || 'None'}
                </Typography>
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {rootFields.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
          No root canvas fields available. Create a root canvas field first.
        </Typography>
      )}
    </Stack>
  );
};
